/**
 * Returns whether the provided company number is valid
 *
 * @param number - string;
 */
export const isValidCompanyNumber = (number: string): boolean => {
	return /(0[0-9]{9})+/i.test(number);
};
